import { useCountDown } from 'ahooks';
import { FC } from 'react';

interface Props {
  expiresAt: string;
}

export const PagesSearchAndReplaceHistoryCountdown: FC<Props> = ({ expiresAt }) => {
  const [, formattedRes] = useCountDown({
    targetDate: expiresAt,
  });
  return `${formattedRes.hours}h ${formattedRes.minutes}m ${formattedRes.seconds}s`;
};
